import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-evento',
  templateUrl: './evento.component.html',
  styleUrls: ['./evento.component.scss']
})
export class EventoComponent implements OnInit {
  url: string;
  cont: any;
  center: any;
  social: any;
  private routeObs: Subscription;
  constructor(
    private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public seo: SeoService,
    public api: RestapiService
  ) {
    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        this.loadContent();
      }, 10);
    });
  }

  ngOnInit(): void {
    this.loadContent()
  }

  loadContent() {
    delete this.cont;
    this.url = this.activatedRoute.snapshot.paramMap.get('url');
    this.api.getdata('webschedule', {
      filters: { id: { value: this.url } }
    }).subscribe(res => {
      if (res.status == true) {
        console.log('CURRENT webschedule', res);
        this.cont = res.result.data[0];
        this.seo.generateTags({
          title:'WWF Educación Ambiental, '+this.cont.tagtitle,
          description: this.cont.tagdescription,
          image: this.api.route + this.cont.tagimage,
          slug: window.location.href,
        });
        this.api.getdata('websection', {
          filters: { id: { value: this.cont.websection_id } }
        }).subscribe(res => {
          if (res.status == true) {
            console.log('CURRENT WEBCESTION CENTER', res);
            this.center = res.result.data[0];
            this.social = {};
            this.center.websectionosocial.forEach(el => {
              this.social[el.name] = el.link;
            });
            console.log('CENTRO RESCATADPO', this.center, this.social)
          }
        })


      }
    })
  }


}
